import { registerActions } from "../actionRegistry";
import { metadataqueue } from "./metadataMisc";
import { dofollow } from "./follow";
import { delegate, getDomElement } from "../utils/dom";
/**
 * Wrapper functions for inline event handlers that were too complex for a plain
 * data-action="call" conversion. The handlers whose only callers were PHP
 * templates were removed with the PHP app; what remains is still emitted by the
 * SSR views.
 */

/* ── artist page: unfold biography ── */
export function unfoldBio(): void {
  document.getElementById("bio_text")?.classList.add("artist-biography-unfold");
  document.getElementById("bio_fade")?.remove();
  document.getElementById("bio_show")?.remove();
}

/* ── interiorengine.php: toggle token details ── */

/* ── collections.php: sidebar expand/collapse ── */
export function sidebarShowLess(catHash: string): void {
  const showmore = document.getElementById(`showmore-${catHash}`);
  const expand = document.getElementById(`sidebar-expand-${catHash}`);
  if (showmore) showmore.style.display = "block";
  if (expand) expand.style.display = "none";
}

export function sidebarShowMore(catHash: string): void {
  const el =
    document.activeElement?.closest<HTMLElement>("[data-action]") ??
    document.querySelector<HTMLElement>(`#showmore-${catHash}`);
  if (el) el.style.display = "none";
  const expand = document.getElementById(`sidebar-expand-${catHash}`);
  if (expand) expand.style.display = "block";
}

/* ── duplicates.php: select master duplicate ── */

/* ── ai-metadata.php: queue start ── */
export function metadataStart(): void {
  metadataqueue();
  document.body.style.overflow = "scroll";
}

/* ── front.php: follow from search ── */
export function followSearch(): void {
  dofollow("3", "search", window.location.pathname);
}

registerActions({
  unfoldBio,
  sidebarShowLess,
  sidebarShowMore,
  metadataStart,
  followSearch,
});

/* ── dashboard payouts: bold the artist's name while hovering its Mark-paid button ──
 * Was `onmouseover="$('#artistname-N').css(…)"` inside a generated HTML string.
 * That worked only because jQuery happens to be on `window`; every other inline
 * handler in the codebase pointed at a registry-only function and silently threw.
 * Delegated here so the markup carries data, not code. */
delegate("mouseover", "[data-highlight]", (_e, el) => {
  const target = getDomElement(el.dataset.highlight ?? "");
  if (target) target.style.fontWeight = "800";
});
delegate("mouseout", "[data-highlight]", (_e, el) => {
  const target = getDomElement(el.dataset.highlight ?? "");
  if (target) target.style.fontWeight = "unset";
});
